import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const StatsBox = ({heading="", desc=""}) => {

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.35,
  });

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.95,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // STATS CARD
  const statVariant = {
    hidden: {
      opacity: 0,
      y: 45,
      scale: 0.96,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        delay: i * 0.12,
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <section className="stats-box-section">

      <div className="container">

        <div className="stats-box">

          {/* LEFT TEXT */}

          <motion.div
            className="stats-left"
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2,
            }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.16,
                },
              },
            }}
          >

            <motion.h2
              className="section-heading"
              variants={fadeUp}
            >
              {heading || "A Proven Track Record"}
            </motion.h2>

            <motion.p
              className="section-text"
              variants={fadeUp}
            >
              {desc || "For over two decades, we’ve helped thousands of clients achieve smooth, secure, and successful property settlements across Western Australia. From local residential suburbs to regional developments, our unwavering dedication to excellence ensures that your property journey is backed by a legacy of trust, unparalleled local expertise, and a commitment to your peace of mind."}
            </motion.p>

          </motion.div>

          {/* RIGHT STATS */}

          <motion.div
            className="stats-right"
            initial={{
              opacity: 0,
              x: 60,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
              amount: 0.2,
            }}
          >

            <motion.div
              className="numbers-box special-stat-section"
              ref={ref}
              variants={{
                hidden: {},
                visible: {
                  transition: {
                    staggerChildren: 0.12,
                  },
                },
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.2,
              }}
            >

              {/* STAT 1 */}

              <motion.div
                className="stat"
                custom={0}
                variants={statVariant}
                whileHover={{
                  y: -8,
                }}
                transition={{
                  duration: 0.3,
                }}
              >

                <h3>
                  {inView && (
                    <CountUp
                      end={20}
                      duration={2.5}
                    />
                  )}
                  +
                </h3>

                <p>Years Of Experience</p>

              </motion.div>

              {/* STAT 2 */}

              <motion.div
                className="stat"
                custom={1}
                variants={statVariant}
                whileHover={{
                  y: -8,
                }}
                transition={{
                  duration: 0.3,
                }}
              >

                <h3>
                  {inView && (
                    <CountUp
                      end={10000}
                      duration={2.5}
                      separator=","
                    />
                  )}
                  +
                </h3>

                <p>Settlements Completed</p>

              </motion.div>

              {/* STAT 3 */}

              <motion.div
                className="stat"
                custom={2}
                variants={statVariant}
                whileHover={{
                  y: -8,
                }}
                transition={{
                  duration: 0.3,
                }}
              >

                <h3>
                  {inView && (
                    <CountUp
                      end={4.3}
                      decimals={1}
                      duration={2.5}
                    />
                  )}
                  +
                </h3>

                <p>Google Ratings</p>

              </motion.div>

              {/* STAT 4 */}

              <motion.div
                className="stat"
                custom={3}
                variants={statVariant}
                whileHover={{
                  y: -8,
                }}
                transition={{
                  duration: 0.3,
                }}
              >

                <h3 className="wa-text">
                  WA Wide
                </h3>

                <p>Your Local Experts</p>

              </motion.div>

            </motion.div>

          </motion.div>

        </div>

      </div>

    </section>
  );
};

export default StatsBox;